import { jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import * as Styled from "./Pill.styled";
export const Pill = forwardRef((props, ref) => {
    const { children, fontSize, palette, text, ...otherProps } = props;
    return (_jsxs(Styled.Pill, { ref: ref, fontSize: fontSize, palette: palette, "data-testid": "Pill", ...otherProps, children: [text, children] }));
});
Pill.displayName = "Pill";
Pill.defaultProps = {
    fontSize: undefined,
    palette: "interactiveNavigational"
};
